import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { ManagePartDTO } from "@shared/models/part-dto";
import { debounceTime, switchMap, tap } from "rxjs/operators";
import { SearchFormDTO } from "./models/search-form-dto";
import { Observable } from "rxjs";
import { PartService } from "@core/services/part.service";
import { MatOptionSelectionChange } from "@angular/material/core";

@Component({
  selector: "app-driveb-part-auto-complete-parts",
  templateUrl: "./part-auto-complete.component.html",
  styleUrls: ["./part-auto-complete.component.scss"],
  standalone: false
})
export class PartAutoCompletePartsComponent implements OnInit {
  loading = false;
  description = new FormControl();

  searchForm = this.fb.group({
    description: this.description
  });

  parts: any[] = [];

  title: string = "";

  @Input() page = "";
  @Output() onChange: any = new EventEmitter<ManagePartDTO>();

  constructor(
    private fb: FormBuilder,
    private partService: PartService,
    private loadingDrivebService: LoadingDrivebService
  ) {}

  ngOnInit() {
    this.getPartName();
  }

  getPartName() {
    this.description.valueChanges
      .pipe(
        debounceTime(200),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const filters = {} as SearchFormDTO;
            filters.description = value;
            return this.partService.findPartsSimplified(filters);
          } else {
            this.loadingDrivebService.setAutoMode(true);
            this.loading = false;
            this.onChange.emit({} as ManagePartDTO);
            return new Observable<ManagePartDTO[]>();
          }
        })
      )
      .subscribe((data) => {
        this.parts = data.content;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      });
  }

  handlePartChange(event: MatOptionSelectionChange, part: ManagePartDTO) {
    if (event.isUserInput === true) {
      this.onChange.emit(part);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.parts = [];
  }

  setValue(value: string): void {
    this.searchForm.get("description").setValue(value);
    this.parts = [];
  }
}
